import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Table from '../../components/Table'
import { Badge } from 'reactstrap'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import tourManager from '../../tours'

class Grid extends Component {
    state = {
        data: [],
        loading: true,
        redirectToLancamento: false,
    }

    getData = (tableState) => {
        this.setState({ loading: true })
        const requestConfig = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        const userInfo = auth.getUserInfo()
        let requestUrl =
            cfg.base_api_url +
            cfg.api_v2 +
            '/' +
            userInfo.empresa +
            `/equipamento/?limit=${tableState?.lineCount}&modelo=8` +
            tableState.filter

        if (tableState.url) {
            requestUrl = tableState.url
        }

        axios.get(requestUrl, requestConfig).then((response) => {
            const { next, previous, results, count } = response.data
            this.setState({ data: results ?? [], loading: false, next, previous, count })
        })
    }

    realizarLancamento = () => {
        const selectedEquipamentoId = this.state.table?.state?.selected[0]
        const equipamentoSelecionado = this.state.data.find(
            (equipamento) => equipamento.id === selectedEquipamentoId
        )

        if (equipamentoSelecionado) {
            this.setState({
                redirectToLancamento: {
                    pathname: `virtual/${equipamentoSelecionado.imei}/lancamento`,
                },
            })
        }
    }

    render() {
        const { redirectToLancamento, table } = this.state

        if (redirectToLancamento)
            return <Redirect to={redirectToLancamento} />

        const columns = [{
            Header: 'Imei',
            Accessor: 'imei'
        }, {
            Header: 'Fabricante',
            Accessor: 'fabricante.nome'
        }, {
            Header: 'Modelo',
            Accessor: 'modelo.modelo',
        }, {
            Header: 'Status',
            Accessor: 'status',
            Cell: (original) => {
                if (original.status === "ativo") {
                    return <Badge href="#" color="success">Ativo</Badge>
                } else if (original.status === "cancelado") {
                    return <Badge href="#" color="secondary">Cancelado</Badge>
                } else if (original.status === "bloqueado") {
                    return <Badge href="#" color="danger">Bloqueado</Badge>
                }
            }
        }]

        return (
            <>
                <div>
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc" style={{ alignItems: 'center' }}>
                            <h4>Reporte de Equipamentos Virtuais</h4>
                            <div className="gray-background">
                                <i className="fa fa-mobile fa-2x"></i>
                            </div>
                            {auth.isMasterOrAdmin() ? (
                            <span
                                data-tour="help-reporte-manual"
                                title="Ajuda"
                                onClick={() => tourManager.start('reporte-manual')}
                                style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                            >
                                <i className="las la-question-circle hdv-help-tour-icon"></i>
                            </span>
                            ) : null}
                        </span>
                    </div>

                    <div className="hdv-btn-group" >
                        <button
                            data-tour="reporte-manual-realizar"
                            onClick={this.realizarLancamento}
                            className="hdv-btn-forms hdv-btn-blue"
                            disabled={!table?.state.enableEditar}>
                            Realizar Reporte
                        </button>
                    </div>

                    <div data-tour="reporte-manual-tabela">
                        <Table
                            checkbox
                            notEditFirstColum={true}
                            data={this.state.data}
                            loading={this.state.loading}
                            count={this.state.count}
                            next={this.state.next}
                            previous={this.state.previous}
                            columns={columns}
                            onFetchData={this.getData}
                            onUpdate={(table) => this.setState({ table })}
                        />
                    </div>
                </div>
            </>
        )
    }
}

export default Grid
